import { render, staticRenderFns } from "./image-upload.vue?vue&type=template&id=7e4b16e2&scoped=true"
import script from "./image-upload.vue?vue&type=script&lang=ts"
export * from "./image-upload.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4b16e2",
  null
  
)

export default component.exports